import { useMemo } from 'react'

import { useGetCityById } from '../../hooks/api/cities/useGetCityById'
import { useGetDriverProfile } from '../../hooks/api/drivers/useGetDriverProfile'
import { useAuthContext } from '../auth/hooks/useAuthContext'

export const useDriverCity = (): string | undefined => {
  const { onboardUserData } = useAuthContext()
  const { data: driverProfile } = useGetDriverProfile()

  // Get city ID from onboarding data if profile doesn't exist yet
  const onboardCityId = useMemo(() => {
    if (onboardUserData?.data?.[0]?.city) {
      const [firstOnboardData] = onboardUserData.data
      const { city } = firstOnboardData
      return typeof city === 'string' ? parseInt(city, 10) : city
    }
    return undefined
  }, [onboardUserData])

  // Fetch city data by ID during onboarding
  const { data: cityData } = useGetCityById(
    onboardCityId || 0,
    (data) => data.name
  )

  // Return city name with priority: profile first, then onboard data
  if (driverProfile?.city?.name) {
    return driverProfile.city.name
  }

  if (cityData) {
    return cityData
  }

  return undefined
}
